import styled from "styled-components";
import { useState } from "react";

export default function Form() {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    whatsapp: "",
    telefone: "",
    assunto: "",
    mensagem: "",
    anexo: null,
  });

  function handleChange(e) {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  }

  function handleSubmit(e) {
    e.preventDefault();

    console.log(formData);
  }

  return (
    <Formulario onSubmit={handleSubmit}>
      <h2>Fale Conosco</h2>

        <label>Nome</label>
      <input
        type="text"
        name="nome"
        placeholder="Nome"
        required
        onChange={handleChange}
      />

        <label>E-mail</label>
      <input
        type="email"
        name="email"
        placeholder="E-mail"
        required
        onChange={handleChange}
      />

        <label>WhatsApp</label>
      <input
        type="text"
        name="whatsapp"
        placeholder="WhatsApp"
        onChange={handleChange}
      />

        <label>Telefone</label>
      <input
        type="text"
        name="telefone"
        placeholder="Telefone"
        onChange={handleChange}
      />

        <label>Assunto</label>
      <input
        type="text"
        name="assunto"
        placeholder="Assunto"
        required
        onChange={handleChange}
      />

        <label>Mensagem</label>
      <textarea
        name="mensagem"
        placeholder="Mensagem"
        rows="5"
        required
        onChange={handleChange}
      />

        <label>Anexo <span>(Não obrigatório)</span></label>
        <input
            type="file"
            name="anexo"
            accept=".pdf,.doc,.docx,.jpg,.png"
            onChange={handleChange}
        />

      <button type="submit">Enviar</button>
    </Formulario>
  );
}

const Formulario = styled.form`
    width: 1000px;
    min-height: 700px;
    display: flex;
    flex-direction: column;

    padding: 20px;
    gap: 15px;

    border-radius: 20px;

    background-color: #f0f8ffc7;

    font-family: "Poppins", sans-serif;

    h2{
        font-size: 25px;
        font-weight:bold;
    }

    input, textarea{
        padding: 10px 12px;
        border-radius: 4px;
        border: 1px solid #cbd5e1;
        font-size: 14px;
    }

    input:focus,textarea:focus {
        outline: none;
        border-color: #2563eb;
    }

    button{
        margin-top: 10px;
        align-self: flex-start;
        background: #2563eb;
        color: #fff;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
    }
`
